// extracted by mini-css-extract-plugin
export default {"cls1":"FmzFfValhf21aI2pOzdJ","cls2":"KmfvoFSr2q1p4pflt8Mq FmzFfValhf21aI2pOzdJ"};